import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';
import {
  AssessmentResponse,
  CampaignContentResponse,
  CampaignResponse,
  InvitationResponse,
  RegistrationRequest,
} from '../models/assessment-api.models';

@Injectable({
  providedIn: 'root',
})
export class AssessApiService {
  private baseUrl: string = environment.api_base_url;

  constructor(private httpClient: HttpClient) {}

  public getInitialAssessment(
    orgCode: string,
    campaignCode: string,
    assessmentId: number,
    invitationCode: string,
  ): Observable<AssessmentResponse> {
    return this.httpClient.get<AssessmentResponse>(
      `${this.baseUrl}/v2/organisations/${orgCode}/campaigns/${campaignCode}/invitations/${invitationCode}/assessments/${assessmentId}`,
    );
  }

  public updateAssessment(
    orgCode: string,
    campaignCode: string,
    assessmentId: number,
    invitationCode: string,
    currentTestlet: string,
    sessionId: string,
    score: number,
    duration: number,
  ): Observable<AssessmentResponse> {
    return this.httpClient.put<AssessmentResponse>(
      `${this.baseUrl}/v2/organisations/${orgCode}/campaigns/${campaignCode}/invitations/${invitationCode}/assessments/${assessmentId}`,
      {
        currentTestlet,
        sessionId,
        score,
        duration,
      },
    );
  }

  public getInvitation(orgCode: string, campaignCode: string, invitationCode: string) {
    return this.httpClient.get<InvitationResponse>(
      `${this.baseUrl}/v1/organisations/${orgCode}/campaigns/${campaignCode}/invitations/${invitationCode}`,
    );
  }

  public getCampaignConfiguration(orgCode: string, campaignCode: string) {
    return this.httpClient.get<CampaignResponse>(
      `${this.baseUrl}/v1/organisations/${orgCode}/campaigns/${campaignCode}/settings`,
    );
  }

  public registerUser(
    orgCode: string,
    campaignCode: string,
    fullName: string,
    email: string,
    externalId: string | null,
  ): Observable<any> {
    const registrationRequest: RegistrationRequest = { email: email, fullName: fullName, externalId: externalId };

    return this.httpClient.post(
      `${this.baseUrl}/v1/organisations/${orgCode}/campaigns/${campaignCode}/registrations`,
      registrationRequest,
      { observe: 'response' },
    );
  }

  public getCampaignContentV1(orgCode: string, campaignCode: string): Observable<CampaignContentResponse> {
    return this.httpClient.get<CampaignContentResponse>(
      `${this.baseUrl}/v1/organisations/${orgCode}/campaigns/${campaignCode}/contents?contentType=${ContentType.Default}`,
    );
  }

  public getCampaignContentV2(orgCode: string, campaignCode: string, invitationCode: string, assessmentId: number): Observable<CampaignContentResponse> {
    return this.httpClient.get<CampaignContentResponse>(
      `${this.baseUrl}/v2/organisations/${orgCode}/campaigns/${campaignCode}/invitations/${invitationCode}/assessments/${assessmentId}/contents?contentType=${ContentType.Default}`,
    );
  }
}

enum ContentType {
  Default = 0,
}
